import { useEffect, useRef, useState } from 'react'

const DEFAULT_PAGE_SIZE = 20

export const useLazyList = (items = [], pageSize = DEFAULT_PAGE_SIZE) => {
  const size = pageSize || DEFAULT_PAGE_SIZE
  const [visibleCount, setVisibleCount] = useState(size)
  const sentinelRef = useRef(null)
  const itemCount = items.length
  const resetKey = `${itemCount}:${items[0]?.id ??
    items[0]?.payment_id ??
    ''}:${items[itemCount - 1]?.id ?? items[itemCount - 1]?.payment_id ?? ''}`

  useEffect(() => {
    setVisibleCount(size)
  }, [resetKey, size])

  useEffect(() => {
    const node = sentinelRef.current
    if (!node || visibleCount >= itemCount) return undefined

    const observer = new IntersectionObserver(
      entries => {
        if (entries[0]?.isIntersecting) {
          setVisibleCount(count => Math.min(count + size, itemCount))
        }
      },
      { rootMargin: '240px 0px' }
    )

    observer.observe(node)
    return () => observer.disconnect()
  }, [itemCount, size, visibleCount])

  return {
    visibleItems: items.slice(0, Math.min(visibleCount, itemCount)),
    sentinelRef,
    hasMore: visibleCount < itemCount
  }
}

export const LAZY_LIST_PAGE_SIZE = DEFAULT_PAGE_SIZE
